import {FC} from 'react';
import styles from './PasswordNumericKeypad.module.css';

const ROWS: Array<Array<string | 'delete' | null>> = [
	['1', '2', '3'],
	['4', '5', '6'],
	['7', '8', '9'],
	[null, '0', 'delete'],
];

interface PasswordNumericKeypadProps {
	value: string;
	maxLength: number;
	disabled?: boolean;
	onDigit: (digit: string) => void;
	onBackspace: () => void;
}

export const PasswordNumericKeypad: FC<PasswordNumericKeypadProps> = ({
	value,
	maxLength,
	disabled,
	onDigit,
	onBackspace,
}) => {
	const canType = !disabled && value.length < maxLength;
	const canDelete = !disabled && value.length > 0;

	const grid = (
		<div className={styles.keypadGrid} role="group" aria-label="Цифровая клавиатура">
			{ROWS.flatMap((row, rowIdx) =>
				row.map((cell, colIdx) => {
					const key = `${rowIdx}-${colIdx}`;
					if (cell === null) {
						return <span key={key} className={styles.cellPlaceholder} aria-hidden="true" />;
					}
					if (cell === 'delete') {
						return (
							<button
								key={key}
								type="button"
								disabled={!canDelete}
								aria-label="Удалить"
								className={styles.key}
								onPointerDown={(e) => e.preventDefault()}
								onClick={() => canDelete && onBackspace()}
							>
								<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M27 25V7H9L4 16L9 25H27Z" stroke="black" strokeWidth="2" />
									<path d="M21 20L13 12" stroke="black" strokeWidth="2" />
									<path d="M13 20L21 12" stroke="black" strokeWidth="2" />
								</svg>
							</button>
						);
					}
					return (
						<button
							key={key}
							type="button"
							disabled={!canType}
							aria-label={`Цифра ${cell}`}
							className={`${styles.key} ${styles.digitKey}`}
							onPointerDown={(e) => e.preventDefault()}
							onClick={() => canType && onDigit(cell)}
						>
							{cell}
						</button>
					);
				}),
			)}
		</div>
	);

	return (
		<>
			<div className={styles.reserve} aria-hidden />
			<div className={styles.fixedBar}>
				<div className={styles.innerWrap}>{grid}</div>
			</div>
		</>
	);
};
